import { getPartnerDuration } from './getPartnerDuration';

/**
 * Returns a display label for how long a partner has been on Noths, e.g.
 * "11 Years" or "5 Months", or null when the join date is missing, invalid, or
 * under a month ago.
 */
export const formatPartnerDuration = (dateJoined?: string): string | null => {
  if (!dateJoined) {
    return null;
  }

  const { count, units } = getPartnerDuration(dateJoined);

  if (count <= 0) {
    return null;
  }

  const unit = units === 'years' ? 'Year' : 'Month';

  return `${count} ${count > 1 ? `${unit}s` : unit}`;
};
